// src/components/landing/ValueGrid.jsx
import React from 'react';
import { useReveal } from '../../utils/reveal';
import {
  IconTable, IconFlow, IconCompliance, IconClimate, IconCost, IconVastu, IconIssue,
} from './LandingIcons';

// The seven focuses. "In development" marks a focus the product does not deliver
// yet — the copy is the positioning, and the tag is what stops the positioning
// being read as a claim by someone doing diligence:
//   - Shared projects: roles, a stakeholder directory and messaging exist, but no
//     project can yet be opened by two accounts.
//   - Cost: the tab exists in the app with no estimator behind it.
const CARDS = [
  { icon: IconTable, title: 'Everyone at the table', status: 'In development',
    text: 'Architects, builders and homeowners work from one project, each seeing what matters to their role.' },
  { icon: IconFlow, title: 'Design to execution, no handoffs',
    text: 'One continuous flow from site and massing to a sanction-ready check, instead of a dozen disconnected tools.' },
  { icon: IconCompliance, title: 'Compliance resolved from the plot',
    text: 'The governing rule is derived from your coordinates, road width and zone — then checked in exact figures, never guessed from a menu.' },
  { icon: IconClimate, title: 'Sustainable from the first massing',
    text: 'Sun, wind and thermal screening run over your actual building at design stage, so climate shapes the design instead of auditing it later.' },
  { icon: IconCost, title: 'Cost the moment the massing exists', status: 'In development',
    text: "A quick, actionable estimate as soon as there's a form to price — before anything is committed." },
  { icon: IconVastu, title: 'Vastu you can trust',
    text: "Read off true north from the plot's own boundary, with every claim cited to its named source and honest about what the text does not say." },
  { icon: IconIssue, title: "Know what's wrong before it's expensive",
    text: 'One analysis pass surfaces the real issues across compliance, climate, cost and Vastu, in plain language.' },
];

export default function ValueGrid() {
  const ref = useReveal();
  return (
    <section id="product" className="lp-section" aria-labelledby="lp-product-title">
      <div className="lp-wrap">
        <h2 id="lp-product-title" className="lp-h2">What VAUOM does</h2>
        <ul ref={ref} className="lp-grid lp-stagger">
          {CARDS.map((c, i) => {
            const Icon = c.icon;
            return (
              <li key={c.title} className="lp-card lp-glow lp-child" style={{ '--i': i }}>
                <span className="lp-icon lp-card-icon" aria-hidden="true"><Icon /></span>
                <h3 className="lp-h3">
                  {c.title}
                  {c.status && <span className="lp-tag">{c.status}</span>}
                </h3>
                <p className="lp-body">{c.text}</p>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
